module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av211-6cd53c38fcadee5f47c3c17c3194ddbf.jpg";